import {
  Badge,
  Button,
  Col,
  Form,
  Input,
  Modal,
  PageHeader,
  Progress,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
  Upload,
  message,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { GlobalUtilityStyle, PaginationStyle } from '../container/styled';
import { InboxOutlined } from '@ant-design/icons';
import axios from '../backendServiceWithoutTimeout';
import axiosUpload from '../backendServiceForUpload';
import { UploadOutlined } from '@ant-design/icons';
import { PlusOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import { FaFile, FaImage } from 'react-icons/fa6';
const { TextArea } = Input;
import AWS from 'aws-sdk';
import { BiEditAlt } from 'react-icons/bi';
import { MdDelete } from 'react-icons/md';
import { GiNotebook } from 'react-icons/gi';

const S3_BUCKET = 'hls-streaming-classroom';
const REGION = 'ap-south-1';
const ACCESS_KEY = 'AKIA4T4OCFU2JPJX5VW5';
const SECRET_ACCESS_KEY = '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';

const s3 = new AWS.S3({
  endpoint: 'https://hls-streaming-classroom.s3.ap-south-1.amazonaws.com',
  accessKeyId: 'AKIA4T4OCFU2JPJX5VW5',
  secretAccessKey: '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',
  region: 'ap-south-1',
  s3BucketEndpoint: true,
});
// Add after the S3 constants
const PDF_FOLDER = 'pdf';
const IMAGE_FOLDER = 'thumbnails';
const DOCUMENT_FOLDER = 'documents';

// Add this helper function
const getFileTypeFolder = (fileType) => {
  if (fileType.includes('pdf')) return 'pdf';
  if (fileType.includes('image')) return 'thumbnails';
  if (fileType.includes('video')) return 'videos';
  if (fileType.includes('text') || fileType.includes('document')) return 'documents';
  return 'documents'; // default folder
};
const Elibrary = () => {
  const [form] = Form.useForm();
  const userId = Cookies.get('userId');

  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState();
  const [pdfFile, setPDFFile] = useState(null);
  const [courseData, setCourseData] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
  const [subjectsToShow, setsubjectsToShow] = useState([]);
  const [courseId, setCourseId] = useState([]);
  const [subjectId, setSubjectId] = useState([]);
  const [pdfFileName, setPDFFileName] = useState('');
  const [fileUploadStatus, setFileUploadStatus] = useState('');
  const [fileReady, setFileReady] = useState(null);
  const [uploadedFileName, setUploadedFileName] = useState('');
  const [fileURL, setFileURL] = useState(null);
  const [imageFileName, setImageFileName] = useState('');
  const [imageReady, setImageReady] = useState(null);
  const [uploadedImageName, setUploadedImageName] = useState('');
  const [imageUploadStatus, setImageUploadStatus] = useState('');
  const [imageURL, setImageURL] = useState(null);
  const [imageUploadPercentage, setImageUploadPercentage] = useState(0);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [showImageUploadBar, setShowImageUploadBar] = useState(true);
  const [showUploadBar, setShowUploadBar] = useState(true);
  const [openDelete, setOpenDelete] = useState(false);
  const [bookToDlt, setBookToDlt] = useState(null);
  // const [batchData, setBatchData] = useState([]);
  // const [chapterData, setChapterData] = useState([]);
  // const [topicData, setTopicData] = useState([]);
  // const [batchesToShow, setbatchesToShow] = useState([]);
  // const [chaptersToShow, setchaptersToShow] = useState([]);
  // const [topicsToShow, settopicsToShow] = useState([]);
  // const [batchId, setBatchId] = useState(null);
  // const [chapterId, setChapterId] = useState(null);
  // const [topicId, setTopicId] = useState(null);

  // For Data table
  const [ebooks, setEbooks] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currBook, setCurrBook] = useState(null);

  const fetchData = async () => {
    const data = {
      userId: userId,
    };
    try {
      setLoading(true);
      const response = await axios.post(`/users/formwise-userData`, data);
      const resData = await response.data;
      setUserData(resData);
      setCourseData(resData.user_courses);
      // setBatchData(resData.user_batches);
      setSubjectData(resData.user_subjects);
      // setChapterData(resData.user_chapters);
      // setTopicData(resData.user_topics);
      setEbooks(resData.user_ebooks);
      setLoading(false);
    } catch (error) {}
  };

  useEffect(() => {
    fetchData();
  }, []);

  /**
   * Data table section
   */
  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: (text) => (
        <Tooltip title={text}>
          <span
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'block',
              maxWidth: '250px',
              paddingLeft: '5px',
            }}
          >
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: 'Author',
      dataIndex: 'author',
      key: 'author',
      render: (text) => (
        <Tooltip title={text}>
          <span
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'block',
              maxWidth: '250px',
              paddingLeft: '5px',
            }}
          >
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: 'Courses',
      dataIndex: 'courses',
      key: 'courses',
      render: (courses, record) => (
        <div className="flex items-center justify-start gap-1 flex-wrap">
          {courses.map((course) => (
            <Badge
              key={course._id} // Assuming each course has a unique _id
              size={'default'}
              count={course.courseName}
              className="text-xs"
              style={{ background: '#865CD3', fontSize: '12px' }}
            />
          ))}
        </div>
      ),
    },
    {
      title: 'Subjects',
      dataIndex: 'subjects',
      key: 'subjects',
      render: (subjects, record) => (
        <div className="flex items-center justify-start gap-1 flex-wrap">
          {subjects.map((subject) => (
            <Badge
              key={subject._id} // Assuming each course has a unique _id
              size={'default'}
              count={subject.subjectName}
              className="text-xs"
              style={{ background: '#865CD3', fontSize: '12px' }}
            />
          ))}
        </div>
      ),
    },
    {
      title: 'Book File',
      dataIndex: 'bookLink',
      key: 'bookLink',
      align: 'center',
      render: (text, record) => (
        <div className="flex items-center justify-center">
          <Button type="primary" onClick={() => handleViewPDF(text)}>
            View book
          </Button>
        </div>
      ),
    },
    {
      title: 'Book Thumbnail',
      dataIndex: 'thumbnailURL',
      key: 'thumbnailURL',
      align: 'center',
      render: (text, record) => (
        <div className="flex items-center justify-center">
          <Button type="primary" onClick={() => handleViewPDF(text)}>
            View thumbnail
          </Button>
        </div>
      ),
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      render: (text, record) => (
        <div className="flex items-center justify-center gap-3 flex-wrap">
          <Tooltip title={`Edit`}>
            <BiEditAlt
              className="mx-2 w-4 h-4 cursor-pointer text-primary dark:text-white60 hover:text-success dark:hover:text-success"
              onClick={() => handleEdit(record)}
            />
          </Tooltip>
          <Tooltip title={`Delete`}>
            <MdDelete
              color="red"
              className="mx-2 w-4 h-4 cursor-pointer text-primary dark:text-white60 hover:text-success dark:hover:text-success"
              onClick={() => handleDelete(record)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  // Display PDF note
  const handleViewPDF = (pdfLink) => {
    window.open(pdfLink, '_blank');
  };

  // Handle search query input change
  const onSearchQueryChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Filter the data based on the search query
  const filteredData = ebooks.filter(
    (book) => book.title.toLowerCase().includes(searchQuery.toLowerCase()),
    // note.title.toLowerCase().startsWith(searchQuery.toLowerCase()),
  );

  /**
   * Add / Edit form section
   */

  // Populate form on edit button
  useEffect(() => {
    const courseNames = currBook?.courses.map((course) => course.courseName).join(', ');
    const courseIds = currBook?.courses.map((course) => course._id);
    const subjectNames = currBook?.subjects.map((subject) => subject.subjectName).join(', ');
    const subjectIds = currBook?.subjects.map((subject) => subject._id);
    if (currBook) {
      form.setFieldsValue({
        title: currBook?.title,
        author: currBook?.author,
        description: currBook?.description,
        // course: courseNames,
        course: currBook.courses ? currBook.courses.map((course) => course._id) : [],
        subject: currBook.subjects ? currBook.subjects.map((course) => course._id) : [],
        // course: currBook?.course.courseName,
        // batch: currBook?.batch.name,
        // subject: currBook?.subject.subjectName,
        // chapter: currBook?.chapter.chapterName,
      });
      setPDFFileName(currBook.bookLink);
      setFileURL(currBook.bookLink);
      setFileUploadStatus('Current file');
      setUploadPercentage(100);
      setImageFileName(currBook.thumbnailURL);
      setImageURL(currBook.thumbnailURL);
      setImageUploadStatus('Current file');
      setImageUploadPercentage(100);
      setFileReady(true);
      setImageReady(true);
      setCourseId(courseIds);
      setSubjectId(subjectIds);
    }
  }, [currBook, form]);

  // Open add / edit modal
  const showModal = () => {
    setCurrBook(null);
    setPDFFileName(null);
    setFileURL(null);
    setFileUploadStatus(null);
    setImageFileName(null);
    setImageURL(null);
    setImageUploadStatus(null);
    form.resetFields();
    setUploadPercentage(0);
    setFileReady(false);
    setImageUploadPercentage(0);
    setImageReady(false);
    setCourseId([]);
    // setBatchId(null);
    setSubjectId(null);
    // setChapterId(null);
    // setTopicId(null);
    setIsOpen(true);
  };

  const closeModal = () => {
    setCourseId([]);
    setsubjectsToShow([]);
    // setbatchesToShow([]);
    // setchaptersToShow([]);
    // settopicsToShow([]);
    setCurrBook(null);
    setIsOpen(false);
  };

  // Open edit modal
  const handleEdit = (record) => {
    setCurrBook(record);
    setIsOpen(true);
  };

  // // Trigger batch filter on courseId change
  // useEffect(() => {
  //   // form.setFieldValue('subject', null);

  //   // form.setFieldValue('batch', null);
  //   // form.setFieldValue('chapter', null);
  //   // form.setFieldValue('topic', null);
  //   // const filteredBatches = batchData.filter((batch) => batch.course === courseId);
  //   // setbatchesToShow(filteredBatches);
  // }, [courseId]);

  // Trigger subject filter on courseId change
  useEffect(() => {
    if (courseId.length < 1) {
      setSubjectId([]);
    }
    // form.setFieldValue('subject', null);
    // form.setFieldValue('chapter', null);
    // form.setFieldValue('topic', null);
    // const currentCourse = courseData.find((course) => course._id === courseId);
    // if (currentCourse) {
    //   const subIdArr = currentCourse.subjects.map((sub) => sub);
    //   const filteredSubjects = subjectData.filter((sub) => subIdArr.includes(sub._id));
    //   setsubjectsToShow(filteredSubjects);
    // }
    const currentCourses = courseId.map((id) => courseData.find((course) => course._id === id)).filter(Boolean); // This will find all courses with IDs in courseId array
    const allSubjects = currentCourses.flatMap((course) => course.subjects); // This will get an array of all subjects from all current courses
    const filteredSubjects = subjectData.filter((sub) => allSubjects.includes(sub._id)); // This will filter subjectData based on subjects from current courses
    setsubjectsToShow(filteredSubjects);
  }, [courseId]);

  // // Trigger chapter filter on subjectId change
  // useEffect(() => {
  //   form.setFieldValue('chapter', null);
  //   form.setFieldValue('topic', null);
  //   // const filteredChapters = chapterData.filter((ch) => ch.subject === subjectId);
  //   // setchaptersToShow(filteredChapters);
  // }, [subjectId]);

  // // Trigger topic filter on chapterId change
  // useEffect(() => {
  //   form.setFieldValue('topic', null);
  //   // const filteredTopics = topicData.filter((tp) => tp.subject === subjectId && tp.chapter === chapterId);
  //   // settopicsToShow(filteredTopics);
  // }, [chapterId]);

  // Handle pdf file upload
  const handlePDFFileUpload = async (file) => {
    setFileReady(false);
    const uniqueSuffix = Date.now() + '-' + Math.round(Math.random() * 1e9);
    const updatedFileName = file.name.replace(/\s/g, '') + '_' + uniqueSuffix;

    // Dynamic folder based on file type
    const folderName = getFileTypeFolder(file.type);
    const s3Key = `${folderName}/${updatedFileName}`;

    setUploadedFileName(updatedFileName);

    const params = {
      Bucket: S3_BUCKET,
      Key: s3Key, // Changed from just updatedFileName
      Body: file,
      ACL: 'public-read',
      ContentType: file.type,
      ContentDisposition: 'inline',
      CreateBucketConfiguration: {
        LocationConstraint: 'ap-south-1',
      },
    };

    try {
      setFileUploadStatus(`Uploading in progress...`);
      setUploadPercentage(0);

      s3.upload(params, (err, data) => {
        if (err) {
          console.log(err);
          return;
        }

        console.log(`File uploaded successfully. ${data.Location}`);
        const pdfURLReceived = data && data.Location;
        if (pdfURLReceived) {
          // Construct proper URL with folder structure
          const finalURL = `https://${S3_BUCKET}.s3.${REGION}.amazonaws.com/${s3Key}`;
          setFileURL(finalURL);
          message.success('File uploaded successfully');
        } else {
          message.error('Failed to upload file. Please try again');
        }
        setFileUploadStatus(`File uploaded successfully.`);
        setFileReady(true);
      }).on('httpUploadProgress', (progressData) => {
        const calculatedProgress = Math.round((progressData.loaded / progressData.total) * 100);
        setUploadPercentage(calculatedProgress);
      });
    } catch (error) {
      console.error('Error uploading file:', error);
      message.error('Failed to upload file');
    }
  };

  const deleteUploadedFile = async (fileName, fileType = null) => {
    try {
      let folderName;

      // Determine folder based on file type or file extension
      if (fileType) {
        folderName = getFileTypeFolder(fileType);
      } else {
        // Fallback: determine by file extension
        const fileExtension = fileName.split('.').pop().toLowerCase();
        if (fileExtension === 'pdf') {
          folderName = 'pdf';
        } else if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension)) {
          folderName = 'thumbnails';
        } else if (['mp4', 'avi', 'mkv', 'webm'].includes(fileExtension)) {
          folderName = 'videos';
        } else {
          folderName = 'documents';
        }
      }

      await axios.delete(`/videos/gets3objects/delete-from-s3/${folderName}/${fileName}`);
      message.success(`File deleted successfully, upload a new file`);
    } catch (error) {
      console.error('Error deleting file:', error);
      message.error('Failed to delete file');
    }
  };

  // Handle image file upload
  const handleImageFileUpload = async (file) => {
    setImageReady(false);
    const uniqueSuffix = Date.now() + '-' + Math.round(Math.random() * 1e9);
    const updatedFileName = file.name.replace(/\s/g, '') + '_' + uniqueSuffix;

    // Dynamic folder based on file type
    const folderName = getFileTypeFolder(file.type);
    const s3Key = `${folderName}/${updatedFileName}`;

    setUploadedImageName(updatedFileName);

    const params = {
      Bucket: S3_BUCKET,
      Key: s3Key, // Changed from just updatedFileName
      Body: file,
      ACL: 'public-read',
      ContentType: file.type,
      ContentDisposition: 'inline',
      CreateBucketConfiguration: {
        LocationConstraint: 'ap-south-1',
      },
    };

    try {
      setImageUploadStatus(`Uploading in progress...`);
      setImageUploadPercentage(0);

      s3.upload(params, (err, data) => {
        if (err) {
          console.log(err);
          return;
        }

        const imageURLReceived = data && data.Location;
        if (imageURLReceived) {
          // Construct proper URL with folder structure
          const finalURL = `https://${S3_BUCKET}.s3.${REGION}.amazonaws.com/${s3Key}`;
          setImageURL(finalURL);
          message.success('Image uploaded successfully');
        } else {
          message.error('Failed to get image URL');
        }
        setImageUploadStatus(`Image uploaded successfully.`);
        setImageReady(true);
      }).on('httpUploadProgress', (progressData) => {
        const calculatedProgress = Math.round((progressData.loaded / progressData.total) * 100);
        setImageUploadPercentage(calculatedProgress);
      });
    } catch (error) {
      console.error('Error uploading image:', error);
      message.error('Failed to upload image');
    }
  };

  // Delete uploaded pdf file from s3 bucket
  const clearUploadedEbookFile = async () => {
    await deleteUploadedFile(uploadedFileName);
    setUploadPercentage(0);
    setFileUploadStatus('');
    setFileURL(null);
    form.setFieldValue('bookPDF', null);
    setPDFFileName('');
    setPDFFile(null);
  };

  // Delete previously uploaded pdf file from s3 bucket
  const clearExistingPDFFile = async () => {
    const link = currBook.bookLink;
    const linkArr = link.split('/');
    const fileKey = linkArr[linkArr.length - 1];
    await deleteUploadedFile(fileKey);
    setUploadPercentage(0);
    setFileUploadStatus('');
    setFileURL(null);
    setPDFFileName('');
    setPDFFile(null);
    form.setFieldValue('bookPDF', null);
  };

  // Delete previously uploaded image file from s3 bucket
  const clearExistingImageFile = async () => {
    const link = currBook.thumbnailURL;
    const linkArr = link.split('/');
    const fileKey = linkArr[linkArr.length - 1];
    await deleteUploadedFile(fileKey);
    setImageUploadPercentage(0);
    setImageUploadStatus('');
    setImageURL(null);
    setImageFileName('');
    form.setFieldValue('bookThumbnail', null);
  };

  // Delete uploaded image file from s3 bucket
  const clearUploadedImageFile = async () => {
    await deleteUploadedFile(uploadedImageName);
    setImageUploadPercentage(0);
    setImageUploadStatus('');
    setImageURL(null);
    form.setFieldValue('bookThumbnail', null);
    setImageFileName('');
  };

  // Open delete modal
  const handleDelete = (record) => {
    setBookToDlt(record._id);
    setOpenDelete(true);
  };

  // Close delete modal
  const closeDeleteModal = () => {
    setOpenDelete(false);
  };

  // Delete EBook
  const handleEBookDelete = async () => {
    try {
      const response = await axios.delete(`/elibrary/delete-ebook/${bookToDlt}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const res = await response.data;
      if (res.statusCode === 201) {
        form.resetFields();
        message.success(response.data.message);
        fetchData();
        closeDeleteModal();
      }
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
      message.error(error.message);
    }
  };

  // Clear all necessary fields
  const clearAllNeccessaryFields = () => {
    setUploadPercentage(0);
    setImageUploadPercentage(0);
    setPDFFileName('');
    setPDFFile(null);
    setImageFileName('');
    form.setFieldValue('bookPDF', null);
    form.setFieldValue('bookThumbnail', null);
    setFileUploadStatus('');
    setImageUploadStatus('');
    setFileURL(null);
    setImageURL(null);
    setFileReady(false);
    setImageReady(false);
  };

  // Handle form submission
  const handleFormSubmit = async (values) => {
    const data = {
      title: values.title,
      author: values.author,
      description: values.description,
      user: userId,
      courses: courseId,
      // batch: batchId,
      subjects: subjectId,
      // chapter: chapterId,
      // topic: topicId ? topicId : '',
      bookLink: fileURL,
      thumbnailURL: imageURL,
    };
    try {
      const response = await axios.post(`/elibrary/add-new-ebook`, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const res = await response.data;
      if (res.statusCode === 201) {
        clearAllNeccessaryFields();
        form.resetFields();
        message.success(response.data.message);
        fetchData();
        closeModal();
      } else if (res.statusCode === 400) {
        message.error(response.data.message);
      }
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }
  };

  // Handle edit form submission
  const handleEditFormSubmit = async (values) => {
    const data = {
      id: currBook?._id,
      title: values.title,
      author: values.author,
      description: values.description,
      user: userId,
      // courses: currBook?.courseId,
      courses: courseId,
      // batch: currBook?.batchId,
      subjects: subjectId,
      // chapter: currBook?.chapterId,
      // topic: currBook?.topicId ? currBook?.topicId : '',
      bookLink: fileURL,
      thumbnailURL: imageURL,
    };
    try {
      const response = await axios.post(`/elibrary/update-ebook`, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const res = await response.data;
      if (res.statusCode === 201) {
        clearAllNeccessaryFields();
        form.resetFields();
        message.success(response.data.message);
        fetchData();
        closeModal();
      } else if (res.statusCode === 400) {
        message.error(response.data.message);
      }
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }
  };

  return (
    <div>
      <PageHeader
        className="flex items-center justify-between px-8 xl:px-[15px] pt-7 pb-6 sm:pb-[30px] bg-transparent sm:flex-col"
        title=""
      />
      <main className="min-h-[715px] lg:min-h-[580px] px-8 xl:px-[15px] bg-transparent">
        <Row gutter={30}>
          <Col xs={24}>
            <>
              <div className="bg-white dark:bg-white10 m-0 text-theme-gray dark:text-white60 text-[15px] rounded-10 relative p-[25px]">
                <div className="text-dark dark:text-white87 font-medium text-[17px] flex items-center justify-between gap-[15px] sm:justify-left mb-5">
                  <div className="flex items-center justify-between gap-[15px]">
                    <h1 className="mb-0 inline-block text-ellipsis text-[18px] font-semibold sm:text-center sm:min-w-max capitalize">
                      E-library books
                    </h1>
                    <Input
                      className="w-[150px]"
                      value={searchQuery}
                      onChange={onSearchQueryChange}
                      placeholder="Search by name..."
                    />
                  </div>
                  <Button
                    onClick={showModal}
                    className="h-[50px] px-6 text-xs font-medium bg-primary-transparent text-primary border-none"
                    transparented
                    type="primary"
                    size="large"
                  >
                    + Add Book
                  </Button>
                </div>
                {/*Display courses list */}
                <div className="mt-0.5">
                  <>
                    <GlobalUtilityStyle>
                      <PaginationStyle>
                        <div className="table-pl-0 hover-tr-none table-pt-15 table-responsive ant-pagination-custom-style [&>div>div>div>ul]:pt-[30px] [&>div>div>div>ul]:mt-[20px] [&>div>div>div>ul]:border-normal dark:[&>div>div>div>ul]:border-white10 [&>div>div>div>ul]:border-t-1 [&>div>div>div>ul]:justify-center">
                          <Table
                            pagination={{ pageSize: 10, showSizeChanger: false }}
                            dataSource={filteredData}
                            columns={columns}
                          />
                        </div>
                      </PaginationStyle>
                    </GlobalUtilityStyle>
                  </>
                </div>
              </div>

              {/* Add new plan Modal */}
              <Modal
                open={isOpen}
                style={{ top: 20 }}
                width={1000}
                // title="Add a new book"
                title={currBook !== null ? 'Edit Book' : 'Add Book'}
                okText={currBook !== null ? 'Update' : 'Create'}
                // okText="Create"
                cancelText="Cancel"
                onCancel={closeModal}
                onOk={() => {
                  form
                    .validateFields()
                    .then((values) => {
                      if (currBook === null) {
                        if (fileReady === true && imageReady === true) {
                          handleFormSubmit(values);
                        } else {
                          message.error(`Wait for file upload to finish`);
                        }
                      } else if (currBook !== null) {
                        if (fileReady === true && imageReady === true) {
                          handleEditFormSubmit(values);
                        } else {
                          message.error(`Wait for file upload to finish`);
                        }
                      }
                    })
                    .catch((info) => {
                      console.log('Validate Failed:', info);
                    });
                }}
              >
                <Form
                  form={form}
                  layout="horizontal"
                  name="form_in_modal"
                  initialValues={{
                    modifier: 'public',
                  }}
                >
                  {/* Enter Title */}
                  <Form.Item
                    name="title"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter title of book',
                      },
                    ]}
                  >
                    <Input autoComplete="off" placeholder="Enter the title of book" />
                  </Form.Item>
                  {/* Enter Author Name */}
                  <Form.Item
                    name="author"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter the name of author',
                      },
                    ]}
                  >
                    <Input autoComplete="off" placeholder="Enter the name of author" />
                  </Form.Item>

                  {/* Enter Description */}
                  <Form.Item
                    name="description"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter the description',
                      },
                    ]}
                  >
                    <TextArea rows={4} autoComplete="off" placeholder="Enter the description of book" />
                  </Form.Item>

                  {/* Select course */}

                  <Form.Item
                    size={'large'}
                    name="course"
                    rules={[{ required: true, message: 'Please select a course!' }]}
                  >
                    {loading && courseData.length === 0 ? (
                      <Select placeholder="Loading courses..." disabled />
                    ) : courseData.length === 0 ? (
                      <Select placeholder="No courses assigned." disabled />
                    ) : (
                      <Select
                        placeholder="Select course"
                        value={courseId}
                        onChange={(selectedCourses) => setCourseId(selectedCourses)}
                        mode="multiple"
                      >
                        {courseData.map((course) => (
                          <Select.Option key={course.courseName} value={course._id}>
                            {course.courseName}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                  {/* Select subjects */}
                  <Form.Item
                    size={'large'}
                    name="subject"
                    rules={[{ required: true, message: 'Please select a subject!' }]}
                  >
                    {loading && subjectsToShow.length === 0 ? (
                      <Select placeholder="Loading subjects..." disabled />
                    ) : subjectsToShow.length === 0 ? (
                      <Select placeholder="No course selected." disabled />
                    ) : (
                      <Select
                        placeholder="Select subject"
                        value={subjectId}
                        onChange={(selectedSubjects) => setSubjectId(selectedSubjects)}
                        mode="multiple"
                      >
                        {subjectsToShow.map((subject) => (
                          <Select.Option key={subject.subjectName} value={subject._id}>
                            {subject.subjectName}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>

                  {/* Select batch */}
                  {/* <Form.Item
                    size={'large'}
                    name="batch"
                    rules={[{ required: true, message: 'Please select a batch!' }]}
                  >
                    {loading && batchesToShow.length === 0 ? (
                      <Select placeholder="Loading batches..." disabled />
                    ) : batchesToShow.length === 0 ? (
                      <Select placeholder="No course selected." disabled />
                    ) : (
                      <Select placeholder="Select batch" onChange={(e) => setBatchId(e)}>
                        {batchesToShow.map((batch) => (
                          <Select.Option key={batch.name} value={batch._id}>
                            {batch.name}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item> */}

                  {/* Select subject */}
                  {/* <Form.Item
                    size={'large'}
                    name="subject"
                    rules={[{ required: true, message: 'Please select a subject!' }]}
                  >
                    {loading && subjectsToShow.length === 0 ? (
                      <Select placeholder="Loading subjects..." disabled />
                    ) : subjectsToShow.length === 0 ? (
                      <Select placeholder="No course selected." disabled />
                    ) : (
                      <Select placeholder="Select subject" onChange={(e) => setSubjectId(e)}>
                        {subjectsToShow.map((subject) => (
                          <Select.Option key={subject.subjectName} value={subject._id}>
                            {subject.subjectName}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item> */}

                  {/* Select chapter */}
                  {/* <Form.Item
                    size={'large'}
                    name="chapter"
                    rules={[{ required: true, message: 'Please select a chapter!' }]}
                  >
                    {loading && chaptersToShow.length === 0 ? (
                      <Select placeholder="Loading chapters..." disabled />
                    ) : chaptersToShow.length === 0 ? (
                      <Select placeholder="No subject selected." disabled />
                    ) : (
                      <Select placeholder="Select chapter" onChange={(e) => setChapterId(e)}>
                        {chaptersToShow.map((chapter) => (
                          <Select.Option key={chapter.chapterName} value={chapter._id}>
                            {chapter.chapterName}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item> */}

                  {/* Select topic */}
                  {/* <Form.Item
                    size={'large'}
                    name="topic"
                    rules={[{ required: true, message: 'Please select a topic!' }]}
                  >
                    {loading && topicsToShow.length === 0 ? (
                      <Select placeholder="Loading topics..." disabled />
                    ) : topicsToShow.length === 0 ? (
                      <Select placeholder="No chapter selected." disabled />
                    ) : (
                      <Select placeholder="Select topic" onChange={(e) => setTopicId(e)}>
                        {topicsToShow.map((topic) => (
                          <Select.Option key={topic.topicName} value={topic._id}>
                            {topic.topicName}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item> */}

                  {/* Upload thumbnail for book */}
                  <Space size={'large'} style={{ display: 'flex', justifyContent: 'start' }} wrap>
                    <Form.Item
                      size="large"
                      name="bookThumbnail"
                      rules={[
                        { required: imageURL === null ? true : false, message: 'Please upload a book thumbnail' },
                      ]}
                    >
                      <Upload
                        style={{ width: '100%' }}
                        maxCount={1}
                        beforeUpload={(file) => {
                          const isAllowedType = file.type.includes('image');
                          const isWithinSizeLimit = file.size <= 400 * 1024; // Convert 200 KB to bytes
                          if (!isAllowedType) {
                            message.error('Only jpg, png files are allowed');
                            return Upload.LIST_IGNORE; // Prevents the file from being added to the upload list
                          }
                          if (!isWithinSizeLimit) {
                            message.error('Image size must be within 400 KB');
                            return Upload.LIST_IGNORE; // Prevents the file from being added to the upload list
                          }
                          return true; // Allows the upload to proceed
                        }}
                        customRequest={(info) => {
                          handleImageFileUpload(info.file);
                          setImageFileName(info.file.name);
                        }}
                        showUploadList={false}
                      >
                        <Button
                          style={{ width: '100%' }}
                          size="large"
                          type="primary"
                          icon={<FaImage />}
                          className="text-sm text-blue-700 gap-2 flex items-center justify-start"
                        >
                          Upload a thumbnail for book
                        </Button>
                      </Upload>
                    </Form.Item>
                    {imageFileName !== '' && imageUploadStatus == 'Image uploaded successfully.' && (
                      <Form.Item size={'large'}>
                        <Space wrap>
                          {imageFileName ? imageFileName : ''}
                          {imageFileName !== '' && (
                            <Button
                              onClick={clearUploadedImageFile}
                              type="default"
                              size="small"
                              className="bg-red-500 text-white"
                            >
                              Delete
                            </Button>
                          )}
                        </Space>
                      </Form.Item>
                    )}
                    {imageUploadStatus !== '' && (
                      <div className="text-xs text-green-500" style={{ color: 'green' }}>
                        {imageUploadStatus}
                      </div>
                    )}
                    {imageUploadStatus === 'Current file' && (
                      <div className="flex items-center gap-2">
                        <Button type="primary" onClick={() => handleViewPDF(imageURL)}>
                          View thumbnail
                        </Button>
                        <Button
                          onClick={clearExistingImageFile}
                          type="default"
                          size="small"
                          className="bg-red-500 text-white"
                        >
                          Delete
                        </Button>
                      </div>
                    )}
                  </Space>
                  {/* Image upload bar */}
                  <div className="mb-5">{showImageUploadBar && <Progress percent={imageUploadPercentage} />}</div>

                  {/* Upload pdf file */}
                  <Space size={'large'} style={{ display: 'flex', justifyContent: 'start' }} wrap>
                    <Form.Item
                      size="large"
                      name="bookPDF"
                      rules={[{ required: fileURL === null ? true : false, message: 'Please upload a pdf file' }]}
                    >
                      <Upload
                        style={{ width: '100%' }}
                        maxCount={1}
                        beforeUpload={(file) => {
                          const isPDF = file.type.includes('pdf');
                          if (!isPDF) {
                            message.error('Only PDF files are allowed');
                            return Upload.LIST_IGNORE;
                          }
                          return true; // Allows the upload to proceed
                        }}
                        customRequest={(info) => {
                          handlePDFFileUpload(info.file);
                          setPDFFile(info.file);
                          setPDFFileName(info.file.name);
                        }}
                        showUploadList={false}
                      >
                        <Button
                          style={{ width: '100%' }}
                          size="large"
                          type="primary"
                          icon={<FaFile />}
                          className="text-sm text-blue-700 gap-2 flex items-center justify-start"
                        >
                          Upload a pdf file of book
                        </Button>
                      </Upload>
                    </Form.Item>
                    {pdfFileName !== '' && fileUploadStatus == 'File uploaded successfully.' && (
                      <Form.Item size={'large'}>
                        <Space wrap>
                          {pdfFileName ? pdfFileName : ''}
                          {pdfFileName !== '' && (
                            <Button
                              onClick={clearUploadedEbookFile}
                              type="default"
                              size="small"
                              className="bg-red-500 text-white"
                            >
                              Delete
                            </Button>
                          )}
                        </Space>
                      </Form.Item>
                    )}
                    {fileUploadStatus !== '' && (
                      <div className="text-xs text-green-500" style={{ color: 'green' }}>
                        {fileUploadStatus}
                      </div>
                    )}
                    {fileUploadStatus === 'Current file' && (
                      <div className="flex items-center gap-2">
                        <Button type="primary" onClick={() => handleViewPDF(fileURL)}>
                          View book
                        </Button>
                        <Button
                          onClick={clearExistingPDFFile}
                          type="default"
                          size="small"
                          className="bg-red-500 text-white"
                        >
                          Delete
                        </Button>
                      </div>
                    )}
                  </Space>
                  {/* File upload bar */}
                  <div className="mb-7">{showUploadBar && <Progress percent={uploadPercentage} />}</div>
                </Form>
              </Modal>
            </>
          </Col>
        </Row>
        {/* Delete modal */}
        <Modal title={'Are you sure delete this e-book?'} open={openDelete} onCancel={closeDeleteModal} footer={null}>
          <div className="flex items-center justify-end gap-2">
            <Button onClick={closeDeleteModal} type={'ghost'}>
              Cancel
            </Button>
            <Button onClick={handleEBookDelete} type={'danger'}>
              Delete
            </Button>
          </div>
        </Modal>
      </main>
    </div>
  );
};

export default Elibrary;
